import { useCallback } from 'react';
import generateUrlWithToken from '../utils/generateUrlWithToken';

export default function useNavigateInNewTab() {
  return useCallback(url => {
    const newUrl = generateUrlWithToken(url);
    window.open(newUrl, '_blank');
  }, []);
}
